import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { ResourcesNavWrapper } from "./style";
import { throttle } from "@website-builder/utilities-index";

const STICKY_MARGIN = 50;
let currentURL = "";

const ResourceSecondaryNavigation = (props) => {
	const { header, resourceLinks } = props;

	const secondaryNavEl = useRef(null);
	const [initialTop, setInitialTop] = useState(null);
	const [sticky, setSticky] = useState(false);

	useEffect(() => {
		window.requestAnimationFrame(() => {
			window.scrollTo(0, 0);
			const top = secondaryNavEl.current.getBoundingClientRect().top;
			setInitialTop(top);
		});
	}, [secondaryNavEl, setInitialTop]);

	useEffect(() => {
		const makeElementSticky = throttle(() => {
			window.requestAnimationFrame(() => {
				const top = secondaryNavEl.current.getBoundingClientRect().top;
				const scrollY = window.scrollY;
				if (sticky) {
					if (initialTop - scrollY >= STICKY_MARGIN) {
						setSticky(false);
					}
				} else {
					if (top <= STICKY_MARGIN) {
						setSticky(true);
					}
				}
			});
		}, 100);

		currentURL = window.location.href;

		window.addEventListener("scroll", makeElementSticky);

		return () => {
			window.removeEventListener("scroll", makeElementSticky);
		};
	}, [initialTop, sticky]);

	return (
		<ResourcesNavWrapper ref={secondaryNavEl} sticky={sticky}>
			<div className="stickyWrapper">
				<div className="linksWrapper">
					<a className="desktopView">{header}</a>
					{resourceLinks.map((resourceLink, index) => (
						<a
							className="selectedBackground"
							key={index}
							href={resourceLink?.link?.link}
							target={resourceLink?.link?.target}
						>
							{resourceLink?.label}
						</a>
					))}
				</div>
			</div>
		</ResourcesNavWrapper>
	);
};

ResourceSecondaryNavigation.defaultProps = {
	header: "",
	resourceLinks: [],
};

ResourceSecondaryNavigation.propTypes = {
	header: PropTypes.string,
	resourceLinks: PropTypes.array,
};

export default ResourceSecondaryNavigation;
